document.addEventListener("DOMContentLoaded", function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;
  let prods = window.product
  function getCur() {
    let option1 = $('#sp-color div.active').attr('data-val')
    let option2 = $('#sp-qty div.active').attr('data-val')
    let option3 = $('#sp-type div.active').attr('data-val')
    // console.log(option1,option2)
    let result=prods.filter(item => item.option1 == option1&&item.option2==option2&&item.option3==option3)[0];
    // console.log("price result",result)
    return result;
  }

  
  let sp_price1 = 8.900;
  let sp_price2 = 12.900;

  function changePrice() {
    let num = $('#calcNumber').val()
    let price = (getCur().price / 100 * num).toFixed(2)
    let compare = (getCur().compare_at_price / 100 * num).toFixed(2)
    // 价格切换时计算的价格基数也要切换
    sp_price1=getCur().price / 100000
    sp_price2=getCur().compare_at_price / 100000
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
    $('#sp_price1').html('$'+  price)
    $('#sp_price2').html('$'+ compare)
    let off_font =
      100 - Math.ceil((price / compare) * 100)
    off_font = off_font
    $('.font-off').html(off_font)
  }

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  new WOW().init();

  jQuery(".sp-scroll").slide({
    mainCell: ".nav-imgs",
    autoPlay: true,
    effect: "leftMarquee",
    interTime: 12,
    vis: 1,
    scroll: 1,
  });

  new Swiper('.mySwiper', {
    slidesPerView: 'auto',
    spaceBetween: 35,
    loop: true, //循环滚动
    freeMode: true,
    speed: 6500, //匀速时间
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: true,
    },
    allowTouchMove: false,
  })

  // 获取所有轮播容器（移动端和PC端）
  const swiperBoxes = document.querySelectorAll(".sp-swiper-box");
  
  // 为每个轮播容器创建独立的控制器
  swiperBoxes.forEach(function(swiperBox) {
    let autoPlayInterval;
    let startX, startY, endX, endY, isSwipe = false;
    let isDragging = false; // 鼠标拖动状态
    
    // 切换到下一张图片
    function showNextSlide() {
      const items = swiperBox.querySelectorAll(".sp-swiper-item");
      if (items.length === 0) return;
      
      // 将第一个元素移到最后
      swiperBox.appendChild(items[0]);
    }
    
    // 切换到上一张图片
    function showPrevSlide() {
      const items = swiperBox.querySelectorAll(".sp-swiper-item");
      if (items.length === 0) return;
      
      // 将最后一个元素移到最前面
      swiperBox.prepend(items[items.length - 1]);
    }
    
    // 开始自动播放
    function startAutoPlay() {
      stopAutoPlay(); // 先清除已有的定时器
      autoPlayInterval = setInterval(showNextSlide, 3000); // 每3秒切换一次
    }
    
    // 停止自动播放
    function stopAutoPlay() {
      if (autoPlayInterval) {
        clearInterval(autoPlayInterval);
        autoPlayInterval = null;
      }
    }
    
    // 初始化轮播
    function initSwiper() {
      const items = swiperBox.querySelectorAll(".sp-swiper-item");
      if (items.length > 0) {
        startAutoPlay();
      }
    }
    
    // 阻止图片拖动
    const images = swiperBox.querySelectorAll("img");
    images.forEach(function(img) {
      img.addEventListener("dragstart", function(e) {
        e.preventDefault();
      });
      img.style.pointerEvents = "none"; // 让鼠标事件穿透到父元素
    });
    
    // ========== 触摸事件（移动端） ==========
    // 触摸开始
    swiperBox.addEventListener("touchstart", function(e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isSwipe = false;
      stopAutoPlay(); // 触摸时停止自动播放
    });

    // 触摸移动
    swiperBox.addEventListener("touchmove", function(e) {
      if (!isSwipe) {
        endX = e.touches[0].clientX;
        endY = e.touches[0].clientY;
        
        const deltaX = Math.abs(endX - startX);
        const deltaY = Math.abs(endY - startY);
        
        // 判断是否为水平滑动
        if (deltaX > deltaY && deltaX > 50) {
          isSwipe = true;
          e.preventDefault(); // 阻止默认的滚动行为
        }
      }
    });

    // 触摸结束
    swiperBox.addEventListener("touchend", function(e) {
      if (isSwipe) {
        const deltaX = endX - startX;
        const minSwipeDistance = 50; // 最小滑动距离
        
        if (Math.abs(deltaX) > minSwipeDistance) {
          if (deltaX > 0) {
            // 向右滑动，显示上一张
            showPrevSlide();
          } else {
            // 向左滑动，显示下一张
            showNextSlide();
          }
        }
      }
      isSwipe = false;
      startAutoPlay(); // 触摸结束后恢复自动播放
    });
    
    // ========== 鼠标事件（PC端） ==========
    // 鼠标按下
    swiperBox.addEventListener("mousedown", function(e) {
      e.preventDefault(); // 阻止默认行为
      isDragging = true;
      startX = e.clientX;
      startY = e.clientY;
      isSwipe = false;
      stopAutoPlay(); // 拖动时停止自动播放
      swiperBox.style.cursor = "grabbing";
    });

    // 鼠标移动（需要监听document，防止鼠标移出容器）
    document.addEventListener("mousemove", function(e) {
      if (!isDragging) return;
      
      endX = e.clientX;
      endY = e.clientY;
      
      const deltaX = Math.abs(endX - startX);
      const deltaY = Math.abs(endY - startY);
      
      // 判断是否为水平拖动
      if (deltaX > deltaY && deltaX > 10) {
        isSwipe = true;
      }
    });

    // 鼠标松开（需要监听document，防止鼠标移出容器）
    document.addEventListener("mouseup", function(e) {
      if (!isDragging) return;
      
      if (isSwipe) {
        const deltaX = endX - startX;
        const minSwipeDistance = 50; // 最小拖动距离
        
        if (Math.abs(deltaX) > minSwipeDistance) {
          if (deltaX > 0) {
            // 向右拖动，显示上一张
            showPrevSlide();
          } else {
            // 向左拖动，显示下一张
            showNextSlide();
          }
        }
      }
      isDragging = false;
      isSwipe = false;
      swiperBox.style.cursor = "grab";
      startAutoPlay(); // 拖动结束后恢复自动播放
    });
    
    // 设置鼠标样式
    swiperBox.style.cursor = "grab";
    swiperBox.style.userSelect = "none"; // 禁止选择文本
    
    // 初始化轮播
    initSwiper();
  });
  
  new Swiper(".sp-swiper1", {
    autoplay: true,
    autoplay: {
      delay: 350000,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
  });

  new Swiper(".sp-swiper2", {
    autoplay: true,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    pagination: {
      el: ".sp-pagination2",
      clickable: true,
    },
  });

  new Swiper(".sp-swiper3", {
    autoplay: true,
    autoplay: {
      delay: 350000,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    pagination: {
      el: ".sp-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".sp-swiper-btn-next",
      prevEl: ".sp-swiper-btn-prev",
    },
  });

  new Swiper(".sp-swiper4", {
    speed: 9000,
    autoplay: true,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    loop: true,
  });

  new Swiper(".sp-swiper-fade", {
    spaceBetween: 10,
    effect: "fade",
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 2000,
    },
    speed: 2000,
  });

  new Swiper(".sp-swiper-fade1", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    loop: true,
    on: {
      slideChange: function (e) {
        e.slides.find(".sp-text").each(function () {
          this.style.animation = "none";
        });
        const spText = e.slides.eq(e.activeIndex).find(".sp-text")[0];
        if (spText) {
          spText.style.animation = "none";

          spText.style.animation = `swiper-up-fade 0.5s ease forwards`;
        }
      },
    },
  });

  new Swiper(".sp-swiper0", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    loop: true,
  });

  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      if (document.body.clientWidth <= 1060) {
        let scale = document.body.clientWidth / 1080;
        $("#root").css("zoom", scale);
      } else {
        const scale = document.body.clientWidth / 1920;
        $("#root").css("zoom", scale);
      }

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              if (document.body.clientWidth <= 1060) {
                let scale = document.body.clientWidth / 1080;
                $("#root").css("zoom", scale);
              } else {
                const scale = document.body.clientWidth / 1920;
                $("#root").css("zoom", scale);
              }
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            if (dataSrc) {
              image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            }
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
      config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();
    
    // 准备图片数组 - 总共8张图片（sp-type有4个选项，sp-qty有2个选项，4*2=8）
    let imgList = [
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20260121-pro1.jpg',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20260121-pro2.jpg',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20260121-pro3.jpg',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20260121-pro4.jpg',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20260121-pro5.jpg',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20260121-pro6.jpg',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20260121-pro7.jpg',

        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/d8438fbca80f11dcdf4cd7420eae08b2.jpg?v=1768565819&width=1946',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/16ad1464527c007e14bf556eabe2b019.jpg?v=1768565820&width=1946',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/8d1d4798bc45baa60444003b6f137b9e.jpg?v=1768565820&width=1946',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/3486eaad0186bea97ac742e186ef0d4f.jpg?v=1768565820&width=1946',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/eb05bb81256aead7cc62802a8facfe34.jpg?v=1768565819&width=1946',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/ba9ce3fdeeacf939f31becb13361190a.jpg?v=1768565820&width=1946',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/b624033761891374aa50eee41d1309e3.jpg?v=1768565820&width=1946',

        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20260121-pro2-1.jpg',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20260121-pro2-2.jpg',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20260121-pro2-3.jpg',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20260121-pro2-4.jpg',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20260121-pro2-5.jpg',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20260121-pro2-6.jpg',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20260121-pro2-7.jpg',

        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/d8438fbca80f11dcdf4cd7420eae08b2.jpg?v=1768565819&width=1946',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/16ad1464527c007e14bf556eabe2b019.jpg?v=1768565820&width=1946',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/8d1d4798bc45baa60444003b6f137b9e.jpg?v=1768565820&width=1946',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/3486eaad0186bea97ac742e186ef0d4f.jpg?v=1768565820&width=1946',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/eb05bb81256aead7cc62802a8facfe34.jpg?v=1768565819&width=1946',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/ba9ce3fdeeacf939f31becb13361190a.jpg?v=1768565820&width=1946',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/b624033761891374aa50eee41d1309e3.jpg?v=1768565820&width=1946',

        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20260121-pro3-1.jpg',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20260121-pro3-2.jpg',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20260121-pro3-3.jpg',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20260121-pro3-4.jpg',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20260121-pro3-5.jpg',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20260121-pro3-6.jpg',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20260121-pro3-7.jpg',

        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/d8438fbca80f11dcdf4cd7420eae08b2.jpg?v=1768565819&width=1946',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/16ad1464527c007e14bf556eabe2b019.jpg?v=1768565820&width=1946',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/8d1d4798bc45baa60444003b6f137b9e.jpg?v=1768565820&width=1946',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/3486eaad0186bea97ac742e186ef0d4f.jpg?v=1768565820&width=1946',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/eb05bb81256aead7cc62802a8facfe34.jpg?v=1768565819&width=1946',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/ba9ce3fdeeacf939f31becb13361190a.jpg?v=1768565820&width=1946',
        'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/b624033761891374aa50eee41d1309e3.jpg?v=1768565820&width=1946',


    ];
    // for (let i = 1; i <= 9; i++) {
    //   imgList.push(`https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20260112-p${i}.png`);
    // }
    
    // 预加载所有图片
    preloadImages(imgList);
    
    // 更新主图显示
    function updateMainImage() {
      let colorIndex = $("#sp-color .sp-option.active").index();
      let qtyIndex = $("#sp-qty .sp-option.active").index();
      let typeIndex = $("#sp-type .sp-option.active").index();

      console.log('colorIndex',colorIndex)
      console.log('qtyIndex',qtyIndex)
      console.log('typeIndex',typeIndex)
      let index = colorIndex + qtyIndex*7 + typeIndex*14
      
      // 更新图片
      $(".sp-img-p").attr('src', imgList[index]);
    }

    // 数量选项点击事件（sp-type）
    // $(".sp-option").click(function () {
    //   $(this).siblings().removeClass("active");
    //   $(this).addClass("active");
    //   updateMainImage();
    // });
    // 颜色选项点击事件（sp-color）
    $("#sp-color .sp-option").click(function () {
      $(this).siblings().removeClass("active");
      $(this).addClass("active");
      updateMainImage();
      changePrice()
    });
    
    // 数量选项点击事件（sp-qty）
    $("#sp-qty .sp-option").click(function () {
      $(this).siblings().removeClass("active");
      $(this).addClass("active");
      
      updateMainImage();
      changePrice()
    });

    // 包装选项点击事件（sp-type）
    $("#sp-type .sp-option").click(function () {
      $(this).siblings().removeClass("active");
      $(this).addClass("active");
      
      updateMainImage();
      changePrice()
    });

    // 跳转支付页面
      $(document).on('click', '.sp-btn-style', function () {
    let num = $('#calcNumber').val()
    window.location.href = '/cart/' + getCur().id + ':' + num
  })


    // 初始化图片
    updateMainImage();

    // IOS字体多了间距的处理
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent);

    if (!isAndroid && !isIOS && !isPC) {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();
  changePrice();

  // 找到所有跳转套餐的锚点链接 - 使用事件委托确保所有链接都能工作
  function handleShoppingLinkClick(event) {
    const link = event.target.closest('a[href="#shopping"]');
    if (!link) return;
    
    event.preventDefault();
    
    const targetElement = document.getElementById("shopping");
    if (targetElement) {
      const offsetTop = targetElement.offsetTop;
      let sptop = document.body.clientWidth <= 1080 ? 50 : 30;
      let zoomValue = parseFloat($("div#root").css("zoom")) || 1;
      const scrollTop = offsetTop * zoomValue - sptop * zoomValue;

      window.scrollTo({
        top: scrollTop,
        behavior: "smooth",
      });
      
      setTimeout(() => {
        if (window.pageYOffset === 0 || Math.abs(window.pageYOffset - scrollTop) > 100) {
          $('html, body').animate({
            scrollTop: scrollTop
          }, 800);
        }
      }, 100);
    }
  }
  
  // 使用事件委托在document上监听所有点击
  document.addEventListener('click', handleShoppingLinkClick);


  function calcTotal(price, num) {
    let result = Number(price) * Number(num);
    return result.toFixed(3);
  }
  $(".sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    $("#sp_price1").html(calcTotal(sp_price1, input.value) + 'Ft');
    $("#sp_price2").html(calcTotal(sp_price2, input.value) + 'Ft');
  });
  $(".sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    $("#sp_price1").html(calcTotal(sp_price1, input.value) + 'Ft');
    $("#sp_price2").html(calcTotal(sp_price2, input.value) + 'Ft');
  });

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span, div");
    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span/div 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade2 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }

  // 菜单
  $(".sp-menu-btn").click(function (e) {
    $(".sp-menu-mask").show();
  });

  $(".sp-menu-mask").click(function (e) {
    $(".sp-menu-mask").hide();
  });

  function getZoomValue() {
    let zoom = $("div#root").css("zoom");
    return parseFloat(zoom) || 1;
  }

  function handleScroll() {
    // let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    // let zoomValue = getZoomValue();
    // let headerHeight = $(".header:visible").height() * zoomValue;
    
    // if (scrollTop > headerHeight) {
    //   $(".sp-pc .sp-header-top").addClass("sp-fixed");
    // } else {
    //   $(".sp-pc .sp-header-top").removeClass("sp-fixed");
    // }
  }

  // 初始检查
  handleScroll();

  // 监听多种滚动事件
  window.addEventListener('scroll', handleScroll, true);
  document.addEventListener('scroll', handleScroll, true);

  $(function () {
    // 判断是否为移动端
    function isMobile() {
      return document.body.clientWidth <= 1060;
    }

    // 购物车加购动效
    $(".cart-btn").click(function () {
      $(this).children("img").addClass("on");
      if (isMobile()) {
        $(".sp-mobile .sp-cart .num").show();
        $(".sp-mobile .sp-cart").addClass("on");
        setTimeout(function () {
          $(".sp-mobile .sp-cart").removeClass("on");
        }, 500);
      } else {
        $(".sp-pc .sp-header-top .sp-cart .num").show();
        $(".sp-pc .sp-header-top .sp-cart").addClass("on");
        setTimeout(function () {
          $(".sp-pc .sp-header-top .sp-cart").removeClass("on");
        }, 500);
      }
      setTimeout(function () {
        $(".cart-btn").children("img").removeClass("on");
      }, 500);
    });

    let initNum = 0;

    $(".product-part .cart-btn").click(function () {
      let spNum = $("#calcNumber")[0].value;
      initNum += Number(spNum);

      // 更新购物车数量
          var data = {
      id: getCur().id,
      quantity: $('#calcNumber').val(),
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
          $('.cardNum').each(function () {
            $(this).html(result.item_count)
          })
          $('.cardNum').removeClass('sp-gray')
        })
      },
      dataType: 'json',
    })
    //   if (isMobile()) {
    //     $(".sp-mobile .cardNum").each(function () {
    //       $(this).html(initNum);
    //     });
    //   } else {
    //     $(".sp-pc .cardNum").each(function () {
    //       $(this).html(initNum);
    //     });
    //   }
    //   $(".cardNum").removeClass("sp-gray");

      var imgs = $(".sp-img-p.active");

      imgs.each(function () {
        var $img = $(this);
        var flyer = $img[0].cloneNode(true);
        flyer.classList.add("sp_clone");

        $(".product-part").append(flyer);
        $(flyer).css({
          width: $img[0].width,
          height: $img[0].height,
          background: "#e7e9ef",
          position: "fixed",
          top: $img[0].offsetTop,
          left: $img.offset().left,
          "z-index": 99,
        });

        let finish, targetTop, targetLeft;
        
        if (isMobile()) {
          // 移动端：飞向底部固定按钮中的购物车
          finish = $(".sp-btn-style2.sp-mobile .sp-cart");
          if (finish.length > 0) {
            targetTop = $(".sp-btn-style2")[0].offsetTop;
            targetLeft = $(".sp-btn-style2 .sp-cart")[0].offsetLeft + finish.width() / 2;
          } else {
            targetTop = 0;
            targetLeft = 0;
          }
        } else {
          // PC端：飞向header中的购物车
          finish = $(".sp-pc .sp-cart");
          if (finish.length > 0) {
            targetTop = finish[0].offsetTop + 20;
            targetLeft = finish[0].offsetLeft;
          } else {
            targetTop = 0;
            targetLeft = 0;
          }
        }

        $(flyer).animate(
          {
            top: targetTop,
            left: targetLeft,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          "linear",
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach();
              }
            );
          }
        );
      });
    });
  });

  // 问答
  $(".q-row").click(function () {
    $(this).parent().toggleClass("sp-show");
  });

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName("sp-fade-box");
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll(".sp-ani");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`;
              span.style.animationDelay = `${index * 0.5 + 0.5}s`;
            });

            observerAni.unobserve(gradually2);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually2);
  }
  // 文本渐出动画
  const graduallyList3 = document.getElementsByClassName("sp-fade-box2");
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll(".sp-ani2");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`;
              span.style.animationDelay = `${index * 0.3 + 1}s`;
            });

            observerAni.unobserve(gradually3);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually3);
  }
});
